import { render, staticRenderFns } from "./ProgressBoard.vue?vue&type=template&id=a06d62cc&scoped=true"
import script from "./ProgressBoard.vue?vue&type=script&lang=js"
export * from "./ProgressBoard.vue?vue&type=script&lang=js"
import style0 from "./ProgressBoard.vue?vue&type=style&index=0&id=a06d62cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06d62cc",
  null
  
)

export default component.exports